module.exports = __webpack_public_path__ + "static/amadi-bc614943d501f8ac273b3121bbcae240.png";